import { Suspense } from 'react';
import { LegalFileTree } from '@features';
import { Box, Skeleton } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { PageLayout } from '../_layout';

export const LegalPage: React.FC = () => {
  const { t } = useTranslation('legal');

  return (
    <PageLayout title={t('TITLE')}>
      <Box py="md">
        <Suspense fallback={<Skeleton height={100} />}>
          <LegalFileTree />
        </Suspense>
      </Box>
    </PageLayout>
  );
};
